import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

/**
 * @see @databases/panel-types
 */
export enum PanelType {
  DatabaseSetup = 'database-setup',
  DuplicateStructure = 'duplicate-structure',
  EntryView = 'entry-view',
  FieldCreate = 'field-create',
  FieldSettings = 'field-settings',
  /**
   * @see {@link https://www.figma.com/design/uG3BVliRjn405sEmhqQaLO/Databases---Native-Embed?node-id=2859-65603&m=dev}
   */
  ViewSettings = 'view-settings',
}

/**
 * @see {@link ShowPanelCommand}
 */
export interface ShowPanelCommandProperties extends CommandProperties {
  type: PanelType;
}

/**
 * Command to show database configuration panels in the native embed experience.
 *
 * This command displays panels for field settings, sorting, filtering, imports,
 * hiding fields, and layout configuration, providing a native experience that
 * integrates with the host application's UI rather than showing within the iframe.
 */
export const ShowPanelCommand = createCommand<ShowPanelCommandProperties, void>(
  'show-panel-command',
);
